import DataGridCustomFilterModule from "../DataGridCustomFilterModule/DataGridCustomFilterModule";
import DataGridCustomPagination from "../Pagination/DataGridCustomPagination";
import {dataGridColumns} from "./dataGridColumns";
import {DataGrid} from "@mui/x-data-grid";
import {filterFields} from "../filterFields";
import './styles.css'

export default function CustomPkbwlTableDataGrid({dataRows, handleFilterValues, dataRowsDisplay, userPermissionsType}) {

    // const allowedFilterList = filterFields[userPermissionsType]
    const allowedFilterList = filterFields
    // console.log(allowedFilterList)

    return (
        <div
            style={{
                marginTop: '2rem',
                height: 1000,
                width: "100%",
                transition: "all 1.5s linear",
            }}
        >

            <DataGridCustomFilterModule
                allowedFilterList={allowedFilterList}
                data={dataRows}
                handleFilterValues={handleFilterValues}
            />

            <DataGrid
                columns={dataGridColumns}
                rows={dataRowsDisplay}

                className="res__mui__table__columns"

                disableAggregation={true}
                disableChildrenFiltering={true}
                disableChildrenSorting={true}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnPinning={true}
                disableColumnReorder={true}
                // disableColumnResize={false}
                disableColumnSelector={true}
                disableRowGrouping={true}
                disableDensitySelector={true}

                // hideFooter={true}
                components={{Pagination: DataGridCustomPagination}}
                pagination={true}

                headerHeight={90}

                // header row styles
                sx={{
                    //multilinear column headers
                    '& .MuiDataGrid-columnHeaderTitle': {
                        textOverflow: "clip",
                        whiteSpace: "break-spaces",
                        lineHeight: 1,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        color: 'white',
                        background: '#0677d2',
                    },
                    fontSize: ".8rem"
                }}

                initialState={{
                    sorting: {
                        sortModel: [{ field: "nr_pkbwl", sort: "desc" }],
                    },
                }}
            />
        </div>
    )
}